import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab } from '@headlessui/react';
import { Panel, PanelBody, PanelHeader, PanelTab } from '../ui/Panel';
import { Curl } from './Curl';
export function RequestRepresentation() {
    return (_jsxs(Tab.Group, { as: Panel, children: [_jsx(Tab.List, { as: PanelHeader, children: _jsx(PanelTab, { children: "Curl" }) }), _jsx(Tab.Panels, { children: _jsx(Tab.Panel, { as: PanelBody, children: _jsx(Curl, {}) }) })] })
    // <Tab.Group as="div">
    //   <div className="flex items-center justify-between py-1">
    //     <Tab.List className="space-x-3">
    //       <RequestRepresentationTab>Curl</RequestRepresentationTab>
    //       {/* <RequestRepresentationTab>Fetch</RequestRepresentationTab> */}
    //     </Tab.List>
    //   </div>
    //   <Tab.Panels>
    //   <Tab.Panel className="bg-gray-50 px-2">
    //       <Curl />
    //     </Tab.Panel>
    //     {/* <Tab.Panel className="bg-gray-50 px-2">
    //       <Fetch />
    //     </Tab.Panel> */}
    //   </Tab.Panels>
    // </Tab.Group>
    );
}
